import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            <footer className="footer__area">
                <div className="footer__top">
                    <div className="container footer-line"></div>
                    <img src="/assets/imgs/thumb/footer.png" alt="Footer background" data-speed="0.5" />
                </div>

                <div className="footer__btm">
                    <div className="container">
                        <div className="row footer__row">
                            <div className="col-xxl-12">
                                <div className="footer__inner">
                                    <div className="footer__widget">
                                        <img className="footer__logo" src="/assets/imgs/logo/footer-logo-white.png" alt="Footer Logo" />
                                        <p>Helping your business reach new heights with digital strategies</p>

                                    </div>

                                    <div className="footer__widget-2">
                                        <h2 className="footer__widget-title">Information</h2>
                                        <ul className="footer__link">
                                            <li><Link to="/">Home</Link></li>
                                            <li><Link to="/about">About Company</Link></li>
                                            <li><Link to="/our-work">Our Work</Link></li>
                                            <li><Link to="https://calendly.com/sacesta/30min">Contact us</Link></li>
                                        </ul>
                                    </div>

                                    <div className="footer__widget-3">
                                        <h2 className="footer__widget-title">Contact Us</h2>
                                        <ul className="footer__contact">
                                            <li>Ahmedabad Gujarat India</li>
                                            <li><a href="tel:918347406455" className="phone">+91 8347406455 </a></li>
                                            <li><a href="mailto:contact@sacesta.com">contact@sacesta.com</a></li>
                                        </ul>
                                    </div>

                                    <div className="footer__widget-4">
                                        <h2 className="project-title">Have a project in your mind?</h2>
                                        <div className="btn_wrapper">
                                            <a href="https://calendly.com/sacesta"
                                                className="wc-btn-primary btn-hover btn-item"><span></span> Book A Meet
                                                <i className="fa-solid fa-arrow-right"></i></a>
                                        </div>
                                        <h3 className="contact-time">09 : 00 AM - 07 : 30 PM</h3>
                                        <h4 className="contact-day">Monday - Saturday</h4>
                                    </div>

                                    <div className="footer__copyright">
                                        <p>© {new Date().getFullYear()} | All rights reserved by <a href="https://www.sacesta.com/"
                                            target="_blank" rel="noreferrer">Sacesta</a>
                                        </p>
                                    </div>

                                    <div className="footer__subscribe">
                                        {/* <!-- <form action="#">
                                            <input type="email" name="email" placeholder="Enter your email">
                                                <button type="submit" className="subs-btn"><i className="fa-solid fa-paper-plane"></i></button>
                                        </form> --> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}

export default Footer